module.exports = __webpack_public_path__ + "img/computer4.2e3cfc4e.gif";